// extracted by mini-css-extract-plugin
module.exports = {"DelayedSpinner":"PageLoader_DelayedSpinner__e7YR_","makeVisible":"PageLoader_makeVisible__3ya4T"};